import React, { useEffect, useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsReact from "highcharts-react-official";
import { ConfigProvider, Dropdown, Form, Input, Menu, Modal } from "antd";
import { useSelector } from "react-redux";
import { fetchWorkspaceAsync } from "src/features/performanceManagement/workspaceSlice";
import { useDispatch } from "react-redux";
import workspaceService from "@services/workspace.service";
import performanceManagementService from "@services/performanceManagement.service";
import toast from "react-hot-toast";
import moment from "moment";

HighchartsExporting(Highcharts);

const { SubMenu } = Menu;

const timezone = new Date().getTimezoneOffset();

Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
});

const options = {
  exporting: {
    enabled: true,
  },
  title: {
    text: "",
    margin: 50,
    style: { fontSize: "2rem", fontWeight: "bold" },
  },
  chart: {
    zoomType: "x",
    style: {
      fontFamily: `Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
    height: "100%"
    },
    exporting: {
      enabled: false,
    },
  },
  credits: {
    enabled: false,
  },
  // colors: ["#2F5EC4", "#45a5f5"],
  plotOptions: {
    line: {
      lineWidth: 2,
      states: {
        hover: {
          lineWidth: 3,
        },
      },
      marker: {
        enabled: false,
      },
    },
    series: {
      allowPointSelect: true,
      dataLabels: {
        enabled: true,
        formatter: function () {
          var dataMax = this.series.dataMax;
          if (this.y === dataMax) {
            return this.y;
          }
        },
      },
    },
  },
  time: {
    timezone: "Asia/Tehran",
    timezoneOffset: timezone,
  },
  yAxis: [
    {
      id: "left1",
      lineWidth: 1,
      title: {
        enabled: false,
      },
    },
    {
      id: "left2",
      title: {
        enabled: false,
      },
    },
    {
      id: "right1",
      lineWidth: 1,
      opposite: true,
      title: {
        enabled: false,
      },
    },
    {
      id: "right2",
      lineWidth: 0,
      opposite: true,
      title: {
        enabled: false,
      },
    },
  ],
  xAxis: [
    {
      id: "bottom1",
      type: "datetime",
      labels: {
        style: { fontWeight: "bold" },
        rotation: 90,
        // format: ""
      },
      lineWidth: 1,
      title: {
        enabled: false,
      },
    },
    {
      id: "bottom2",
      type: "datetime",
      labels: {
        style: { fontWeight: "bold" },
        rotation: 90,
        // format: ""
      },
      lineWidth: 1,
      title: {
        enabled: false,
      },
    },
  ],
  tooltip: {
    shared: true,
    crosshairs: true,
  },
  // legend: {
  //   enabled: false,
  // },
  series: [
   
],
};

const menu = (exportFileAs) => (
  <Menu className="w-32">
    <SubMenu title="Download" className="w-32" key="chart-download">
      <Menu.Item key="png" onClick={() => exportFileAs("image/png")}>
        png
      </Menu.Item>
      <Menu.Item key="jpeg" onClick={() => exportFileAs("image/jpeg")}>
        jpeg
      </Menu.Item>
      <Menu.Item key="pdf" onClick={() => exportFileAs("application/pdf")}>
        pdf
      </Menu.Item>
      <Menu.Item key="svg" onClick={() => exportFileAs("image/svg+xml")}>
        svg
      </Menu.Item>
    </SubMenu>
  </Menu>
);

const dates = [
  "Last Day",
  "Last 7 Days",
  "Last 2 Weeks",
  "Last 3 Weeks",
  "Last 30 Days",
];

function Result() {
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const chartRef = useRef(null);
  const { data: counters } = useSelector((state) => state.pms);
  const { data: kpis } = useSelector((state) => state.kpis);

  function exportFileAs(output) {
    if (chartRef.current) {
      chartRef.current.chart.exportChart({
        type: output,
      });
    } else {
      toast.error("Chart Not Found");
    }
  }

  async function saveWorkspace(values) {
    let tmpCounters = [...counters];

    tmpCounters = tmpCounters.map((counter) => {
      let d = { ...counter };
      d.data = [];
      return d;
    });

    try {
      await workspaceService.createWorkspace({
        ...values,
        kpi_query_list: JSON.stringify(tmpCounters),
      });
      setIsModalVisible(false);
      dispatch(fetchWorkspaceAsync());
      toast.success("Workspace saved");
    } catch (error) {
      console.log(error);
      toast.error("Action has error");
    }
  }

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (chartRef && chartRef.current) {
      const seriesLength = chartRef.current.chart.series.length;
      console.log("seriesLength", seriesLength)
      // for (var i = seriesLength - 1; i > -1; i--) {
      //   const id = chartRef.current.chart.series[i].options.id;

      //   if (!counters || !counters.length) {
      //     chartRef.current.chart.series[i].remove();
      //   } else if (!(counters.findIndex((x) => x.id === id) > -1)) {
      //     chartRef.current.chart.series[i].remove();
      //   }
      // }

      // eslint-disable-next-line array-callback-return
      counters.map(async (counter, i) => {
        
        let data = counter.data;
        // if (!data || !data.length) {
        //   const res = await performanceManagementService.fetchKpi({
        //     startDate: counter.startDate,
        //     endDate: counter.endDate,
        //     scope: counter.scope,
        //     kpi_id: counter.kpi_id,
        //     value: counter.value,
        //     buket: counter.buket,
        //   });

        //   data = res.data;
        // }

        try {
          const name =
            (kpis.findIndex((x) => x._id === counter.kpi_id) > -1
              ? kpis.find((x) => x._id === counter.kpi_id).name ||
              counter.kpi_id
              : counter.kpi_id) +
            ` - ${counter.buket} - ${counter.value} (${dates.includes(counter.startDate)
              ? `${counter.startDate}`
              : `${counter.startDate} -> ${counter.endDate}`
            })`;
            
          if (chartRef.current.chart.get(counter.id)) {
            const series = chartRef.current.chart.get(counter.id);
            series.setData({
              type: counter.type,
              // id: counter.id,
              yAxis: counter.align.y,
              xAxis: counter.align.x,
              visible: counter.show,
              color: counter.color,
              name,
              data: counter.data
              // data: data.reduce((result, item) => {
              //   const myDate = new Date(item.datetime);
              //   const result2 = myDate.getTime();

              //   result.push([
              //     result2,
              //     item.kpi === null
              //       ? null
              //       : Number(Number(item.kpi).toFixed(4)),
              //   ]);

              //   return result;
              // }, []),
            });

            if (counter.counters && counter.counters.length) {
              counter.counters.forEach((c) => {
                chartRef.current.chart.addSeries({
                  showInLegend: false,
                  type: counter.type,
                  id: counter.id + "_" + c,
                  visible: counter.counterShow,
                  yAxis: counter.align.y,
                  xAxis: counter.align.x,
                  name: name + "_" + c,
                  color: counter.color,
                  data: data.reduce((result, item) => {
                    const myDate = new Date(item.datetime);
                    const result2 = myDate.getTime();

                    result.push([
                      result2,
                      item.kpi === null
                        ? null
                        : Number(Number(item[c]).toFixed(4)),
                    ]);

                    return result;
                  }, []),
                });
              });
            }
          } else {
            console.log("xxx", counter.data);
            for (let index = 0; index < counter.data.length; index++) {
              const kpi = counter.data[index];
              console.log("kpi", kpi);
              chartRef.current.chart.addSeries({
                // type: counter.type,
                // id: counter.id,
                visible: counter.show,
                yAxis: counter.align.y,
                xAxis: counter.align.x,
                name:kpi.name,
                color: counter.color,
                data:kpi.data
                // data: data.reduce((result, item) => {
                //   const myDate = new Date(item.datetime);
                //   const result2 = myDate.getTime();
  
                //   result.push([
                //     result2,
                //     item.kpi === null
                //       ? null
                //       : Number(Number(item.kpi).toFixed(4)),
                //   ]);
  
                //   return result;
                // }, []),
              });
            }
            // chartRef.current.chart.addSeries({
            //   // type: counter.type,
            //   // id: counter.id,
            //   visible: counter.show,
            //   yAxis: counter.align.y,
            //   xAxis: counter.align.x,
            //   name,
            //   color: counter.color,
            //   data:counter.data[0].data
            //   // data: data.reduce((result, item) => {
            //   //   const myDate = new Date(item.datetime);
            //   //   const result2 = myDate.getTime();

            //   //   result.push([
            //   //     result2,
            //   //     item.kpi === null
            //   //       ? null
            //   //       : Number(Number(item.kpi).toFixed(4)),
            //   //   ]);

            //   //   return result;
            //   // }, []),
            // });

            if (counter.counters && counter.counters.length) {
              counter.counters.forEach((c) => {
                chartRef.current.chart.addSeries({
                  showInLegend: false,
                  type: counter.type,
                  id: counter.id + "_" + c,
                  visible: counter.counterShow,
                  yAxis: counter.align.y,
                  xAxis: counter.align.x,
                  name: name + "_" + c,
                  color: counter.color,
                  data: data.reduce((result, item) => {
                    const myDate = new Date(item.datetime);
                    const result2 = myDate.getTime();

                    result.push([
                      result2,
                      item.kpi === null
                        ? null
                        : Number(Number(item[c]).toFixed(4)),
                    ]);

                    return result;
                  }, []),
                });
              });
            }
          }
        } catch (e) {
          console.log(e);
        }
      });
    }
    // eslint-disable-next-line
  }, [counters]);

  return (
    <>
      <div className="flex flex-col h-full w-full">
        <div className="flex justify-between items-center">
          <div className="flex-shrink-0 flex items-center">
            <span className="font-light text-lg text-gray-700 tracking-wide">
              Details
            </span>
          </div>
          {counters.length > 0 && (
            <div className="flex ">
              <button
                type="button"
                onClick={showModal}
                className="transition-all px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded text-gray-700 text-xs"
              >
                Save As Workspace
              </button>
            </div>
          )}
        </div>

        <div style = {{height:"100vh"}} className={`h-100  bg-white border  border-gray-200 rounded p-5 pt-7`}>
          {/* <div className="flex justify-between items-center mb-12 px-2">
            <h5 className="text-gray-750 mb-0">ATS</h5>

            <ConfigProvider direction="rtl">
              <Dropdown
                overlay={menu(exportFileAs)}
                trigger={["click"]}
                placeholder="bottomRight"
                className="cursor-pointer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-gray-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                  />
                </svg>
              </Dropdown>
            </ConfigProvider>
          </div> */}

          <HighchartsReact
          
            ref={chartRef}
            highcharts={Highcharts}
            options={options}
          />
        </div>
      </div>

      <Modal
        title="Save Workspace"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form layout="vertical" form={form} onFinish={saveWorkspace}>
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Form>
        {/* <p>Do you Want to save this item?</p> */}
      </Modal>
    </>
  );
}

export default Result;
